import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../../hooks/use-http";

import Modal from "react-modal";
import moment from "moment";
import { toast } from "react-toastify";

const AqcForm = (props) => {
  const modalStyles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.75)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 10,
    },
    content: {
      backgroundColor: "#fff",
      padding: "20px",
      top: "20%",
      left: "25%",
      borderRadius: "5px",
      maxWidth: "700px",
      maxHeight: "auto",
      height: "auto",
      width: "100%",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
    },
  };
  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().substr(0, 10)
  );

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };

  const [loading, setLoading] = useState(false);

  const currentDate = new Date().toISOString().slice(0, 10);
  const frmRef = useRef({});

  const productRef = useRef({});
  const [productDetails, setProductDetails] = useState([]);
  const [close, setClose] = useState(false);

  const freshnessRef = useRef({});
  const [freshnessDetails, setFreshnessDetails] = useState(false);
  const [freshnessClose, setFreshnessClose] = useState(false);
  const [units, setUnits] = useState(false);
  const [lengthUnits, setlengthUnits] = useState(false);

  const [decimalPattern, setDecimalPattern] = useState(
    localStorage.getItem("decimalPattern")
  );
  const [integerPattern, setIntegerPattern] = useState(
    localStorage.getItem("integerPattern")
  ); // ;

  const { sendRequest: getPRdata } = useHttp();

  const { sendRequest: getEmp } = useHttp();
  const [employeeId, setEmployeeId] = useState();

  const { sendRequest: getunits } = useHttp();

  useEffect(() => {
    getunits(
      {
        url: `/api/units?orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (res) => {
        if (res) {
          //  setUnits(res);
          //console.log(res);

          const filteredUnits =
            res && res.filter((item) => item.unitTypeId == 2);
          //console.log(filteredUnits);
          setUnits(filteredUnits);
          const filteredUnits1 =
            res && res.filter((item) => item.unitTypeId == 5);
          setlengthUnits(filteredUnits1);
        }
      }
    );
  }, [getunits]);

  useEffect(() => {
    getEmp(
      {
        url: `/api/employee/?useCase=Warehouse&orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (data) => {
        setEmployeeId(data.output);
      }
    );
  }, [getEmp]);
  const { sendRequest: postAqc } = useHttp();

  var d = new Date();
  var dateString =
    d.getDate() +
    "/" +
    (d.getMonth() + 1) +
    "/" +
    d.getFullYear() +
    " " +
    d.getHours() +
    ":" +
    d.getMinutes() +
    ":" +
    d.getSeconds();

  const submitHandler = (e) => {
    e.preventDefault();
    if (freshnessDetails === false) {
      toast.error("Freshness data required");
      return;
    }
    if (productDetails.length === 0) {
      toast.error("Product Details required");
      return;
    }
    setLoading(true);

    const data = {
      aqcDate: moment(frmRef.current.aqc_date.value).format("DD/MM/YYYY"),
      SupervisorEmployeeId: frmRef.current.emp_id.value,
      outTime: moment().format("HH:mm:ss"),
      dateofArrival: moment(frmRef.current.arrival_date.value).format(
        "DD/MM/YYYY"
      ),
      procurementRecieptId: frmRef.current.procurement_reciept_id.value,
      productDetails: productDetails,
      temperature: frmRef.current.temp.value,
      deficiencies: frmRef.current.deficiencies.value,
      freshness: freshnessDetails,
      harvestDate: moment(frmRef.current.harvest_date.value).format(
        "DD/MM/YYYY"
      ),
      avgUnitWeight: frmRef.current.avg_unit_weight.value,
      unitId: frmRef.current.unit.value,
      remark: frmRef.current.remark.value,
      shelfLifeDays: frmRef.current.shelfLifeDays.value,
      createdBy: parseInt(localStorage.getItem("id")),
      orgId: localStorage.getItem("orgId"),
      status: 1,
      createdDate: dateString,
      warehouseId: parseInt(localStorage.getItem("warehouseId")),
      serviceId: props.sId,
    };
    if (props.update) {
      data["aqcId"] = props.update.aqcId;
    }
    //console.log(data);
    postAqc(
      {
        url: "/api/arrivalQualityCheck/",
        method: props.update ? "PUT" : "POST",
        body: data,
      },
      (data) => {
        // //console.log(data);

        toast.success(`AQC Data ${props.update ? "Updated" : "Added"}`);
        setLoading(false);


        props.addForm(false);

      },(error) => {
       
        console.error("Error", error);
        toast.error(error);
        setLoading(false);
      }
    );
  };
  useEffect(() => {
    //console.log(props.update);
    loadPrProduct(props.update.procurementRecieptId);
    if (props.update) {
     
      frmRef.current.emp_id.value = props.update.SupervisorEmployeeId;
      frmRef.current.arrival_date.value = props.update.dateofArrival
        .split("/")
        .reverse()
        .join("-");
      

      frmRef.current.temp.value = props.update.temperature;
      frmRef.current.deficiencies.value = props.update.deficiencies;

      frmRef.current.harvest_date.value = props.update.harvestDate
        .split("/")
        .reverse()
        .join("-");
      frmRef.current.avg_unit_weight.value = props.update.avgUnitWeight;
      frmRef.current.unit.value = props.update.Unit;
      frmRef.current.remark.value = props.update.remark;
      frmRef.current.shelfLifeDays.value = props.update.shelfLifeDays;
      setFreshnessDetails(props.update.freshness);
    }
  }, [props.update]);

  const submitProduct = (e) => {
    e.preventDefault();
    setProductDetails((x) => [
      ...x,
      {
        srno:
          productDetails.length > 0
            ? productDetails[productDetails.length - 1].srno + 1
            : 1,
        itemId:
          productDetails.length > 0
            ? productDetails[productDetails.length - 1].srno + 1
            : 1,
        itemDescription: productRef.current.itemDescription.value,
        itemType: productRef.current.itemType.value,
        itemCategory: productRef.current.itemCategory.value,
        itemQuantity: productRef.current.itemQuantity.value,
        unit: productRef.current.unit.value,
      },
    ]);
  };

  const handleReceiptIdChange = (e) => {
    //console.log(e.target.value);
    const id = e.target.value;
    // setPrProduct();
    loadPrProduct(id);
    const filterdData =
      prData &&
      prData.filter(
        (item) => parseInt(item.procurementRecieptId) === parseInt(id)
      );

    //console.log(filterdData[0]);
  };

  useEffect(() => {
    if (freshnessClose && freshnessDetails) {
      freshnessRef.current.avg_unit_size.value =
        freshnessDetails.avgUnitSize || "";
      freshnessRef.current.unit.value = freshnessDetails.unit;
      freshnessRef.current.shape.value = freshnessDetails.shape;
      freshnessRef.current.colour.value = freshnessDetails.colour;
      freshnessRef.current.unit.value = freshnessDetails.fleshFirmness;
    }
  }, [freshnessClose]);

  const handleDelete = (index, e) => {
    setProductDetails(productDetails.filter((v, i) => i !== index));
  };

  const submitFreshness = (e) => {
    e.preventDefault();
    // const requiredFields = [
    //   "avg_unit_size",
    //   "unit",
    //   "shape",
    //   "colour",
    //   "flesh_firmness",
    // ];
    // const isAnyFieldEmpty = requiredFields.some(
    //   (field) => !freshnessRef.current[field].value
    // );

    // if (isAnyFieldEmpty) {
    //   toast.info("Fill all the fields");
    //   return;
    // }

    setFreshnessDetails({
      avgUnitSize: freshnessRef.current.avg_unit_size.value,
      unitId: freshnessRef.current.unit.value,
      shape: freshnessRef.current.shape.value,
      colour: freshnessRef.current.colour.value,
      fleshFirmness: freshnessRef.current.unit.value,
    });

    setFreshnessClose(false);
  };
  const { sendRequest: getProcurementReciept } = useHttp();

  const [prData, setPrData] = useState();

  useEffect(() => {
    getProcurementReciept(
      {
        url: `/api/getProcurementRecieptForLot/?warehouseId=1`,
      },
      (data) => {
        //console.log(data.ProcurementReciept);
        setPrData(data.ProcurementReciept);
      }
    );
  }, [getProcurementReciept]);

  const { sendRequest: getPrProduct } = useHttp();

  const loadPrProduct = (id) => {
    getPrProduct(
      {
        url: `/api/getProcurementRecieptProductForLot/?procurementRecieptId=${id}`,
      },
      (res) => {
        setProductDetails(res.ProcurementReciept);
      }
    );
  };

  return (
    <>
      {" "}
      {freshnessClose && (
        <div>
          <Modal isOpen={true} style={modalStyles}>
            <div className="">
              <h3 className="card-title">Freshness Details</h3>
              <div className="card-tools text-right">
                <button
                  type="button"
                  className="btn btn-tool"
                  data-card-widget="remove"
                  onClick={() => setFreshnessClose(false)}
                >
                  <i className="fas fa-times" />
                </button>
                <hr />
              </div>
            </div>
            <div>
              <div className="row mb-2">
                <div className="col-md-3">
                  <label htmlFor={"avg_unit_size"}>Average Unit Size</label>
                  <input
                    type={"input"}
                    id={"avg_unit_size"}
                    required
                    ref={(el) => (freshnessRef.current["avg_unit_size"] = el)}
                    className="form-control"
                  />
                </div>
                <div className="col-md-3">
                  <label htmlFor={"unit"}>Unit</label>
                  <select
                    id="unit"
                    className="drop-prod form-control"
                    ref={(el) => (freshnessRef.current["unit"] = el)}
                  >
                    <option value="">Select</option>
                    {lengthUnits &&
                      lengthUnits.map((x, i) => (
                        <option key={i} value={x.unitId}>
                          {x.unitAbbreviation}
                        </option>
                      ))}
                  </select>
                </div>
                <div className="col-md-3">
                  <label htmlFor={"shape"}>Shape</label>
                  <select
                    id="shape"
                    className="form-control"
                    ref={(el) => (freshnessRef.current["shape"] = el)}
                  >
                    <option value="Round">Round</option>
                    <option value="Conic">Conic</option>
                    <option value="Oblate">Oblate</option>
                    <option value="Oblong">Oblong</option>
                    <option value="Oblique">Oblique</option>
                    <option value="Ovate">Ovate</option>
                    <option value="Other">Other</option>
                  </select>
                </div>
              </div>

              <div className="row mb-2">
                <div className="col-md-3">
                  <label htmlFor={"colour"}>Colour</label>
                  <input
                    type={"input"}
                    id={"colour"}
                    required
                    ref={(el) => (freshnessRef.current["colour"] = el)}
                    className="form-control"
                  />
                </div>
                <div className="col-md-3">
                  <label htmlFor={"flesh_firmness"}>Flesh Firmness</label>
                  <select
                    id="flesh_firmness"
                    className="drop-prod form-control"
                    ref={(el) => (freshnessRef.current["flesh_firmness"] = el)}
                  >
                    <option value="Soft">Soft</option>
                    <option value="Moderate">Moderate</option>
                    <option value="Hard">Hard</option>
                  </select>
                </div>
              </div>
              <div className="text-center mb-2">
                <button
                  className="btn btn-sm btn-primary"
                  onClick={submitFreshness}
                >
                  Save
                </button>
              </div>
            </div>
          </Modal>
        </div>
      )}
      {close && (
        <Modal isOpen={true} style={modalStyles}>
          <div className="">
            <h3 className="card-title">Product Details</h3>
            <div className="card-tools text-right">
              <button
                type="button"
                className="btn btn-tool"
                data-card-widget="remove"
                onClick={() => setClose(false)}
              >
                <i className="fas fa-times" />
              </button>
              <hr />
            </div>
          </div>

          <table className="table table-bordered table-sm">
            <thead>
              <tr className="tableheaderrowview">
                <th>Sr. No</th>
                <th>Item Id</th>

                <th>Item Type</th>
                <th>Item Category</th>
                <th>Item Description</th>
                <th>Item Quantity</th>
                <th>Unit</th>
              </tr>
            </thead>
            <tbody>
              {productDetails &&
                productDetails.map((itm, i) => {
                  return (
                    <tr key={i}>
                      <td>{i + 1}</td>
                      <td>{itm.itemId}</td>
                      <td>{itm.cropName}</td>
                      <td>{itm.varietyName}</td>
                      <td>{itm.productName}</td>
                      <td>{itm.itemQuantity}</td>
                      <td>{itm.unitAbbreviation}</td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
          <hr />
          <div className="text-center mt-3">
            <button
              className="btn btn-sm btn-primary"
              onClick={() => {
                productDetails.map((x) => (x["isSave"] = true));
                setClose(false);
              }}
            >
              Save
            </button>
          </div>
        </Modal>
      )}
      <div className="content-wrapper">
        <section className="content">
          <div className="container-fluid">&nbsp;
            <div className="card card-default">
              <form onSubmit={submitHandler}>
                <div className="card-header">
                  <h3 className="card-title">Arrival Quality Check Form</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                <div className="card-body">
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"aqc_date"}> {"AQC Date "}</label>
                      <input
                        type={"date"}
                        id={"aqc_date"}
                        required
                        ref={(el) => (frmRef.current["aqc_date"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={
                          props.update
                            ? props.update.aqcDate
                                .split("/")
                                .reverse()
                                .join("-")
                            : selectedDate
                        }
                        onChange={handleDateChange}
                      />
                    </div>

                    <div className="col-md-3">
                      <label htmlFor={"emp_id"}>{"Assign Supervisor"}</label>

                      <select
                        id="emp_id"
                        className="form-control dropdowns"
                        required
                        ref={(el) => (frmRef.current["emp_id"] = el)}
                      >
                        <option selected disabled value="">
                          select
                        </option>
                        {employeeId &&
                          employeeId.map((x) => (
                            <option
                              value={x.empId}
                              selected={
                                props.update &&
                                props.update.SupervisorEmployeeId == x.empId
                              }
                            >
                              {x.employeeName}
                            </option>
                          ))}
                      </select>
                    </div>

                    <div className="col-md-3">
                      <label htmlFor={"arrival_date"}>
                        {" "}
                        {"Date of Arrival"}
                      </label>
                      <input
                        type={"date"}
                        id={"arrival_date"}
                        required
                        ref={(el) => (frmRef.current["arrival_date"] = el)}
                        className="form-control"
                        max={selectedDate}
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"procurement_reciept_id"}>
                        {"Procurement Reciept id"}
                      </label>
                      <select
                        id={"procurement_receipt_id"}
                        className="form-control dropdowns"
                        required
                        onChange={handleReceiptIdChange}
                        ref={(el) =>
                          (frmRef.current["procurement_reciept_id"] = el)
                        }
                      >
                        <option selected disabled value="">
                          select
                        </option>
                        {prData &&
                          prData.map((x, i) => (
                            <option
                              key={i}
                              value={x.procurementRecieptId}
                              selected={
                                props.update &&
                                props.update.procurementRecieptId ==
                                  x.procurementRecieptId
                              }
                            >
                              {x.procurementRecieptNo}
                            </option>
                          ))}
                      </select>
                    </div>
                  </div>

                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"product_details"}>
                        {" "}
                        {"Product Details"}
                      </label>
                      <br />
                      &nbsp;&nbsp;
                      <button
                        type={"button"}
                        id={"product_details"}
                        autoComplete="off"
                        onClick={() => {
                          // setProductDetails((items) => items.filter((x) => x.isSave  || x.procurementRecieptId));
                          setClose(true);
                        }}
                        ref={(el) => (frmRef.current["product_details"] = el)}
                        className="btn btn-sm btn-success"
                      >
                        View
                      </button>
                    </div>

                    <div className="col-md-3">
                      {" "}
                      <label htmlFor={"temp"}> {"Temperature (°C) "}</label>
                      <input
                        type={"number"}
                        id={"temp"}
                        maxLength={5}
                        required
                        pattern={decimalPattern}
                        ref={(el) => (frmRef.current["temp"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"deficiencies"}> {"Deficiencies"}</label>
                      <select
                        id="deficiencies"
                        className="form-control dropdowns"
                        ref={(el) => (frmRef.current["deficiencies"] = el)}
                      >
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                      </select>
                    </div>

                    <div className="col-md-3">
                      <label htmlFor={"freshness"}> {"Freshness"}</label>
                      <br />
                      &nbsp;&nbsp;
                      <button
                        type={"button"}
                        id={"freshness"}
                        ref={(el) => {
                          if (el) frmRef.current["freshness"] = el;
                        }}
                        className="btn btn-sm btn-warning"
                        autoComplete="off"
                        onClick={() => {
                          setFreshnessClose(true);
                        }}
                      >
                        Add
                      </button>
                    </div>
                  </div>

                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"harvest_date"}> {"Harvest Date"}</label>
                      <input
                        type={"date"}
                        id={"harvest_date"}
                        required
                        ref={(el) => (frmRef.current["harvest_date"] = el)}
                        className="form-control"
                        max={selectedDate}
                      />
                    </div>
                    <div className="col-md-3">
                      {" "}
                      <label htmlFor={"avg_unit_weight"}>
                        {" "}
                        {"Average Unit Weight"}
                      </label>
                      <input
                        type={"number"}
                        id={"avg_unit_weight"}
                        pattern={decimalPattern}
                        required
                        ref={(el) => (frmRef.current["avg_unit_weight"] = el)}
                        className="form-control"
                      />
                    </div>

                    <div className="col-md-3">
                      {" "}
                      <label htmlFor={"unit"}>{"Unit"}</label>
                      <select
                        id="unit"
                        required
                        className="form-control dropdowns"
                        ref={(el) => (frmRef.current["unit"] = el)}
                      >
                        <option selected disabled value="">
                          select
                        </option>

                        {units &&
                          units.map((x) => (
                            <option value={x.unitId}>{x.unitName}</option>
                          ))}
                      </select>
                    </div>

                    <div className="col-md-3">
                      <label htmlFor={"shelfLifeDays"}>
                        {" "}
                        {"Shelf Life Days"}
                      </label>
                      <input
                        type={"number"}
                        id={"shelfLifeDays"}
                        required
                        pattern={integerPattern}
                        ref={(el) => (frmRef.current["shelfLifeDays"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"remark"}>{"Remark/Note"}</label>
                      <input
                        type={"text"}
                        id={"remark"}
                        ref={(el) => (frmRef.current["remark"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>

                  <div className=" text-right">
                    <button
                      type="submit"
                      className="btn btn-primary"
                      disabled={loading}
                    >
                      {loading ? "Submitting..." : "Submit"}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default AqcForm;
